<div mat-dialog-title class="modal-title">
  <mat-icon svgIcon="custom-unlock"></mat-icon>
  <h5>¿Has olvidado tu contraseña?</h5>
  <div>
    <span>Ingresa el email con el que estás registrado.</span>
    <br />
    <span> Te enviaremos las instrucciones de recuperación.</span>
  </div>
</div>
<mat-dialog-content>
  <form [formGroup]="restoreForm">
    <div class="form-control-modal">
      <mat-form-field customColor="light" appearance="outline">
        <mat-label>Email</mat-label>
        <input matInput formControlName="email" name="email" placeholder="Tu email" autocomplete="off" />
        <mat-error> Email requerido </mat-error>
      </mat-form-field>
    </div>
  </form>
</mat-dialog-content>
<mat-dialog-actions class="dialog-actions-container">
  <div class="modal-actions-container">
    <button mat-flat-button color="primary" (click)="closeModal()" class="cancel-modal-button"> Cancelar </button>
    <button
      mat-flat-button
      color="primary"
      (click)="sendRestorePasswordEmail()"
      [disabled]="restoreForm.invalid || isSendingEmail"
      class="submit-modal-button"
    >
      @if (!isSendingEmail) {
        <span>Enviar correo de restauración</span>
      } @else {
        <mat-spinner class="white-spinner"></mat-spinner>
      }
    </button>
  </div>
</mat-dialog-actions>
